import { ActionButton, FeedItem } from '@knocklabs/client';
import { MessageDescriptor } from 'react-intl';
import { getNotificationWorkflow } from '../../workflows';

/**
 * Returns action buttons from the Knock `actions` button_set block,
 * plus FE-injected actions from the workflow descriptor.
 */
export function getNotificationItemButtons(
  item: FeedItem,
  formatMessage: (descriptor: MessageDescriptor) => string,
): ActionButton[] {
  const actionsBlock = item.blocks?.find((block) => block.name === 'actions');
  const fromKnock =
    actionsBlock && actionsBlock.type === 'button_set' ? (actionsBlock.buttons ?? []) : [];

  const workflow = getNotificationWorkflow(item.source?.key);
  const data = (item.data ?? {}) as Record<string, unknown>;
  const fromWorkflow = (workflow?.actions?.(data) ?? []).map((action) => ({
    name: action.name,
    label: formatMessage(action.label),
    action: action.url,
  }));

  return [...fromKnock, ...fromWorkflow];
}
